import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames/bind";
import styles from "./Login.module.css";
import { ToastContext } from "~/components/context/ToastContext";
import { useNavigate } from "react-router-dom";
import { BASE_AUTH_URL } from "~/helper/apiService";

const cx = classNames.bind(styles);

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${BASE_AUTH_URL}check-login`, {
          credentials: "include",
        });
        if (response.ok) {
          const data = await response.json();
          localStorage.setItem("user", JSON.stringify(data.user));
          if (data.user.role === "admin") {
            navigate("/admin");
          } else if (data.user.role === "driver") {
            navigate(`/driver/${data.user.id}`);
          } else {
            navigate("/login");
          }
        } else {
          localStorage.removeItem("user");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error checking auth:", error);
        localStorage.removeItem("user");
        navigate("/login");
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogin = async () => {
    if (!email || !password) {
      showToast("Vui lòng nhập email và mật khẩu", "error");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_AUTH_URL}login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
        credentials: "include",
      });

      const data = await response.json();
      if (response.ok) {
        showToast(data.message, "success");
        localStorage.setItem("user", JSON.stringify(data.user));
        setEmail("");
        setPassword("");
        if (data.user.role === "admin") {
          navigate("/admin");
        } else if (data.user.role === "driver") {
            navigate(`/driver/${data.user.id}`);
        } else {
          showToast("Vai trò người dùng không hợp lệ", "error");
          navigate("/login");
        }
      } else {
        showToast(data.error || "Đăng nhập thất bại", "error");
      }
    } catch (error) {
      showToast("Lỗi kết nối: " + error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={cx("login-container")}>
      <h2 className={cx("title")}>Đăng Nhập</h2>
      <div className={cx("login-form")}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={cx("input")}
          disabled={isLoading}
        />
        <input
          type="password"
          placeholder="Mật khẩu"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={cx("input")}
          disabled={isLoading}
        />
        <button
          onClick={handleLogin}
          className={cx("button")}
          disabled={isLoading}
        >
          {isLoading ? "Đang đăng nhập..." : "Đăng Nhập"}
        </button>
      </div>
    </div>
  );
}

export default Login;